export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f4ca914a3fbad6dc374904b3a21b78301a9c60074&name=fetchTypeahead!'